module.exports = "<div class=\"capeRedirect\">\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/redirect-to-cape/template.html
 ** module id = 481
 ** module chunks = 1
 **/